import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useExpense, useUpdateExpense, useUploadReceipt } from '../../../hooks/useExpenses';
import { useToast } from '../../../hooks/useToast';
import ExpenseForm from '../../../components/forms/ExpenseForm';
import Loading from '../../../components/common/Loading';
import ErrorMessage from '../../../components/common/ErrorMessage';
import { ArrowLeft } from 'lucide-react';

const ExpenseEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { data: expense, isLoading, error, refetch } = useExpense(id);
  const updateExpense = useUpdateExpense();
  const uploadReceipt = useUploadReceipt();
  const toast = useToast();

  const handleSubmit = async (data) => {
    try {
      const { receiptFile, ...expenseData } = data;
      await updateExpense.mutateAsync({ id, data: expenseData });

      if (receiptFile) {
        try {
          await uploadReceipt.mutateAsync({ id, file: receiptFile });
        } catch (uploadError) {
          toast.warning('Despesa atualizada, mas erro ao enviar comprovante: ' + uploadError.message);
          navigate('/admin/despesas');
          return;
        }
      }

      toast.success('Despesa atualizada com sucesso!');
      navigate('/admin/despesas');
    } catch (error) {
      toast.error('Erro ao atualizar despesa: ' + error.message);
    }
  };

  if (isLoading) {
    return <Loading text="Carregando despesa..." />;
  }

  if (error) {
    return <ErrorMessage message={error.message} onRetry={refetch} />;
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div>
        <button
          onClick={() => navigate('/admin/despesas')}
          className="flex items-center text-gray-600 hover:text-gray-900 mb-4"
        >
          <ArrowLeft className="h-5 w-5 mr-2" />
          Voltar para lista
        </button>
        <h1 className="text-2xl font-bold text-gray-900">Editar Despesa</h1>
        <p className="text-gray-600 mt-1">
          Atualize as informações da despesa
        </p>
      </div>

      {/* Form */}
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6">
        <ExpenseForm
          initialData={expense}
          onSubmit={handleSubmit}
          isLoading={updateExpense.isPending || uploadReceipt.isPending}
        />
      </div>
    </div>
  );
};

export default ExpenseEdit;
